export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ADMINS = 'admins',

	PRODUCT_MODULES = 'product-modules',
	PRODUCT_MODULES_CATEGORIES = 'product-module-categories',
	PROJECTS = 'projects',
	PARTNER_ACCOUNT = 'account',
	LANDSCAPE_MODUELS = 'landscape-modules',
	PRODUCT_MODULE_COLLECTIONS = 'product-module-collections',
	MATERIALS = 'materials',
	PLAYGROUND_FILLINGS = 'playgorund-fillings',
	MODELS = 'models',
	ROLES = 'roles',
	MERCHANTS = 'merchants',
	CATEGORIES = 'categories',
	CONTENT = 'content',
	PARTNERS = 'partners',
}
